import React from "react";
import classNames from "classnames";
import { pluralizeWithCount } from "@common/helpers/string";
import { Link } from "@design-system/Link/Link";
import styles from "./CounterpartyDetailsPanel.module.scss";

interface Props {
    count: number;
    /** Singular record name, used in the link's accessible name. */
    recordName: string;
    onOpen?: () => void;
}

/** A record count that opens the records it counts; zero is plain text. */
export const CounterpartyRecordCount: React.FC<Props> = ({
    count,
    recordName,
    onOpen,
}) => (
    <span className={classNames(styles.value, styles.amount)}>
        {count > 0 && onOpen ? (
            <Link
                size="xs"
                onClick={onOpen}
                aria-label={`View ${pluralizeWithCount(recordName, count)}`}
            >
                {count}
            </Link>
        ) : (
            <span className={classNames({ [styles.emptyValue]: count === 0 })}>
                {count}
            </span>
        )}
    </span>
);
